import toggleSidebar from "./actions";
import Sidebar from "./components";

//export components
export default Sidebar;

//export actions
export { toggleSidebar };
